import { RootState } from '../store';

const getVerificationState = (state: RootState) => state.verification;
const getInputEmail = (state: RootState) => state.verification.inputEmail;
const getVerifiedEmail = (state: RootState) => state.verification.verifiedEmail;
const isVerified = (state: RootState) => state.verification.isVerified;
const getError = (state: RootState) => state.verification.error;
const getMessage = (state: RootState) => state.verification.message;

export const VerificationSelector = {
  getVerificationState,
  isVerified,
  getInputEmail,
  getVerifiedEmail,
  getError,
  getMessage,
};